/* */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';
import { toString, isEmpty, isArray } from 'lodash';

const { getManageContactServlet } = actions;
export default (isSendPage = false, typeContact = '0', filters = {}) => {
  const authReducer = useSelector((state) => state.authReducer);
  const manageContacts = useSelector((state) => state.contactServletReducer.manageContacts);
  const error = useSelector((state) => state.contactServletReducer.error);
  const optionContacts = useSelector((state) => state.contactServletReducer.optionContacts);
  const dispatch = useDispatch();

  const isAllContactsLoaded = !isEmpty(optionContacts);

  const refetch = (bodyRefetch) => {
    dispatch(
      getManageContactServlet(
        bodyRefetch || {
          isSendPage,
          typeContact: toString(typeContact),
          filters,
        }
      )
    );
  };

  useEffect(() => {
    if (authReducer.isLogin) {
      if (isSendPage && isAllContactsLoaded) {
        return;
      }

      dispatch(
        getManageContactServlet({
          isSendPage,
          typeContact: toString(typeContact),
          filters,
        })
      );
    }
  }, [isSendPage, authReducer.isLogin, typeContact, isAllContactsLoaded]);

  return useMemo(() => {
    const manageContactsExported = isArray(manageContacts) ? manageContacts : [];

    return [refetch, manageContactsExported, error];
  }, [refetch, manageContacts, error]);
};
